"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8728],{

/***/ 12215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CommentContent; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./lib/miolo/index.ts + 26 modules
var miolo = __webpack_require__(71019);
// EXTERNAL MODULE: ./node_modules/punycode/punycode.es6.js
var punycode_es6 = __webpack_require__(3689);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-linkify/dist/index.js
var dist = __webpack_require__(53731);
// EXTERNAL MODULE: ./components/palette.ts
var palette = __webpack_require__(19889);
;// CONCATENATED MODULE: ./components/discussions/getSafeCommentContent.ts
function getSafeCommentContent(possiblyUnsafeContent) {
    return possiblyUnsafeContent.replace(/(\n{2,})/g, "\n\n");
};

;// CONCATENATED MODULE: ./components/discussions/CommentContent.tsx







function CommentContent(param) {
    var _truncatedCommentLength = param.truncatedCommentLength, truncatedCommentLength = _truncatedCommentLength === void 0 ? 600 : _truncatedCommentLength, bodyAsPlainText = param.bodyAsPlainText;
    var fullCommentContent = getSafeCommentContent(bodyAsPlainText);
    var truncatedCommentContent = fullCommentContent.slice(0, truncatedCommentLength);
    var ref = (0,react.useState)(truncatedCommentContent), displayingContent = ref[0], setDisplayingContent = ref[1];
    var hasTruncation = truncatedCommentContent.length !== fullCommentContent.length;
    var isDisplayingTruncatedContent = displayingContent.length !== fullCommentContent.length;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        className: "flex flex-col space-y-3",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                className: "font-aeonik text-sm font-normal leading-6 tracking-wider text-gray-600 dark:text-gray-400",
                css: {
                    whiteSpace: "pre-line",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                    overflowWrap: "break-word"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
                    // eslint-disable-next-line react/no-unstable-nested-components
                    componentDecorator: function(href, text, key) {
                        var linkText = punycode_es6/* default.toUnicode */.ZP.toUnicode(text).replace(/^https?:\/\//i, "");
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            href: punycode_es6/* default.toUnicode */.ZP.toUnicode(href),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            css: {
                                color: palette/* link */.p4,
                                textDecoration: "none",
                                wordBreak: "break-word",
                                "&:hover": {
                                    textDecoration: "underline"
                                },
                                "&:visited": {
                                    color: palette/* linkVisited */.wR
                                }
                            },
                            children: linkText.length > 25 ? "".concat(linkText.slice(0, 25), "...") : linkText
                        }, key);
                    },
                    children: isDisplayingTruncatedContent ? "".concat(displayingContent, "...") : displayingContent
                })
            }),
            isDisplayingTruncatedContent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkButton */.Qj, {
                    onClick: function() {
                        return setDisplayingContent(fullCommentContent);
                    },
                    children: "Ver mais"
                })
            }),
            hasTruncation && !isDisplayingTruncatedContent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(miolo/* LinkButton */.Qj, {
                    onClick: function() {
                        return setDisplayingContent(truncatedCommentContent);
                    },
                    children: "Ver menos"
                })
            })
        ]
    });
};


/***/ }),

/***/ 14477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ transformOnSingleCommentRootQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _lib_graphql_queries_discussions_AssetDiscussionCommentByShortId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37126);


function transformOnSingleCommentRootQuery(dataProxy, commentShortId, transform) {
    try {
        var queryData = dataProxy.readQuery({
            query: _lib_graphql_queries_discussions_AssetDiscussionCommentByShortId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
            variables: {
                commentShortId: commentShortId
            }
        });
        if (!queryData) {
            return;
        }
        if (!queryData.assetDiscussionCommentByShortId) {
            return;
        }
        var transformResult = transform(queryData.assetDiscussionCommentByShortId);
        if (transformResult === null) {
            dataProxy.writeQuery({
                query: _lib_graphql_queries_discussions_AssetDiscussionCommentByShortId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
                variables: {
                    commentShortId: commentShortId
                },
                data: {
                    __typename: "Query",
                    assetDiscussionCommentByShortId: null
                }
            });
            return;
        }
        dataProxy.writeQuery({
            query: _lib_graphql_queries_discussions_AssetDiscussionCommentByShortId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
            variables: {
                commentShortId: commentShortId
            },
            data: {
                __typename: "Query",
                assetDiscussionCommentByShortId: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, queryData.assetDiscussionCommentByShortId, transform(queryData.assetDiscussionCommentByShortId))
            }
        });
    } catch (err) {} // eslint-disable-line
};


/***/ }),

/***/ 16624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ReplyCommentInputForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99534);
/* harmony import */ var _home_runner_work_web_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_runner_work_web_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_web_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35944);
/* harmony import */ var lib_miolo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71019);
/* harmony import */ var final_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95142);
/* harmony import */ var react_final_form_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20521);
/* harmony import */ var lib_utils_form_restartForm__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58827);
/* harmony import */ var _lib_utils_form_checkCanSubmit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41324);
/* harmony import */ var _lib_utils_form_validateFormValuesAgainstSchema__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23443);
/* harmony import */ var _core_Avatar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96822);
/* harmony import */ var _palette__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(19889);
/* harmony import */ var _shared_form_InlineErrorSpan__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(11602);
/* harmony import */ var _CommentInputTextArea__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29099);
/* harmony import */ var _shapes_commentInputFormDataShape__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99962);
/* harmony import */ var _translateServerErrorIntoFriendlyMessage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43376);




















function ReplyCommentInputForm(param) {
    var viewer = param.viewer, _bodyAsPlainText = param.bodyAsPlainText, bodyAsPlainText = _bodyAsPlainText === void 0 ? "" : _bodyAsPlainText, _hideAvatar = param.hideAvatar, hideAvatar = _hideAvatar === void 0 ? false : _hideAvatar, _autoFocus = param.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, _hintAboutSupportMessagesBeingDeleted = param.hintAboutSupportMessagesBeingDeleted, hintAboutSupportMessagesBeingDeleted = _hintAboutSupportMessagesBeingDeleted === void 0 ? true : _hintAboutSupportMessagesBeingDeleted, onCancel = param.onCancel, onSubmit = param.onSubmit;
    var _ref = (0,react_final_form_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useForm */ .cI)({
        onSubmit: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_home_runner_work_web_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, form) {
                var bodyAsPlainText;
                return _home_runner_work_web_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            bodyAsPlainText = param.bodyAsPlainText;
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return onSubmit(bodyAsPlainText);
                        case 4:
                            setTimeout(function() {
                                (0,lib_utils_form_restartForm__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(form);
                            }, 1);
                            _ctx.next = 12;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](1);
                            if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ctx.t0, Error)) {
                                _ctx.next = 11;
                                break;
                            }
                            return _ctx.abrupt("return", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, final_form__WEBPACK_IMPORTED_MODULE_2__/* .FORM_ERROR */ .Ck, (0,_translateServerErrorIntoFriendlyMessage__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_ctx.t0)));
                        case 11:
                            return _ctx.abrupt("return", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, final_form__WEBPACK_IMPORTED_MODULE_2__/* .FORM_ERROR */ .Ck, "Erro desconhecido"));
                        case 12:
                            return _ctx.abrupt("return", null);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        7
                    ]
                ]);
            }));
            return function(_, form) {
                return _ref.apply(this, arguments);
            };
        }(),
        validate: (0,_lib_utils_form_validateFormValuesAgainstSchema__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_shapes_commentInputFormDataShape__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z),
        initialValues: {
            bodyAsPlainText: bodyAsPlainText
        }
    }), form = _ref.form, handleSubmit = _ref.handleSubmit, submitting = _ref.submitting, submitError = _ref.submitError, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_ref, [
        "form",
        "handleSubmit",
        "submitting",
        "submitError"
    ]);
    var bodyAsPlainTextField = (0,react_final_form_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useField */ .U$)("bodyAsPlainText", form);
    var canSubmit = submitting ? false : (0,_lib_utils_form_checkCanSubmit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(props);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("div", {
        css: {
            display: "grid",
            gridColumnGap: 16,
            gridTemplateColumns: hideAvatar ? "1fr" : "42px 1fr"
        },
        children: [
            !hideAvatar && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_core_Avatar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                src: viewer.pictureUrl,
                hashValue: viewer._id,
                alt: viewer.fullName,
                size: 42,
                css: {
                    WebkitBackfaceVisibility: "hidden"
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("form", {
                onSubmit: handleSubmit,
                css: {
                    display: "grid",
                    gridRowGap: 20
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_CommentInputTextArea__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, bodyAsPlainTextField.input), {
                        autoFocus: autoFocus,
                        hintAboutSupportMessagesBeingDeleted: hintAboutSupportMessagesBeingDeleted,
                        placeholder: "Escreva uma resposta aqui..."
                    })),
                    (bodyAsPlainTextField.input.value || "").trim() && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)("div", {
                        css: {
                            display: "grid",
                            gridTemplateColumns: "1fr max-content",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("div", {
                                children: bodyAsPlainTextField.meta.touched && bodyAsPlainTextField.meta.error && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_shared_form_InlineErrorSpan__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    children: bodyAsPlainTextField.meta.error
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("div", {
                                className: "font-normal",
                                css: {
                                    display: "flex",
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(lib_miolo__WEBPACK_IMPORTED_MODULE_1__/* .ButtonGroup */ .hE, {
                                    stack: "horizontally",
                                    spacing: 20,
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(lib_miolo__WEBPACK_IMPORTED_MODULE_1__/* .LinkButton */ .Qj, {
                                            disabled: submitting,
                                            variant: "black",
                                            onClick: function() {
                                                (0,lib_utils_form_restartForm__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(form);
                                                if (onCancel) {
                                                    onCancel();
                                                }
                                            },
                                            children: "Cancelar"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(lib_miolo__WEBPACK_IMPORTED_MODULE_1__/* .RaisedButton */ .pi, {
                                            disabled: !canSubmit,
                                            type: "submit",
                                            variant: canSubmit ? "primary" : "disabled",
                                            height: 36,
                                            children: submitting ? "Aguarde..." : "Responder"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    submitError && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("div", {
                        css: {
                            padding: 12,
                            color: _palette__WEBPACK_IMPORTED_MODULE_19__/* .stiletto */ .uL,
                            backgroundColor: _palette__WEBPACK_IMPORTED_MODULE_19__/* .vanillaIce */ .q,
                            borderRadius: 6
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("p", {
                            css: {
                                margin: 0,
                                fontSize: 14,
                                lineHeight: 1.33,
                                letterSpacing: 1
                            },
                            children: submitError
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 89669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ReplyToAssetDiscussionCommentMutation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(63659);
// EXTERNAL MODULE: ./components/discussions/apollo/transformOnAssetDiscussionCommentWithRepliesCountFields.ts
var transformOnAssetDiscussionCommentWithRepliesCountFields = __webpack_require__(91490);
// EXTERNAL MODULE: ./lib/amplitude/Amplitude.tsx
var Amplitude = __webpack_require__(89514);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
// EXTERNAL MODULE: ./lib/graphql/fragments/AssetDiscussionCommentReplyFields.ts
var AssetDiscussionCommentReplyFields = __webpack_require__(12149);
;// CONCATENATED MODULE: ./lib/graphql/mutations/discussions/ReplyToAssetDiscussionComment.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ReplyToAssetDiscussionComment($commentId: ObjectID!, $bodyAsPlainText: String!) {\n    replyToAssetDiscussionComment(commentId: $commentId, bodyAsPlainText: $bodyAsPlainText) {\n      _id\n      ...AssetDiscussionCommentReplyFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var ReplyToAssetDiscussionComment = ((0,lib/* default */.ZP)(_templateObject(), AssetDiscussionCommentReplyFields/* default */.Z));

// EXTERNAL MODULE: ./components/discussions/apollo/transformOnDiscussionCommentsRootQuery.ts
var transformOnDiscussionCommentsRootQuery = __webpack_require__(335);
// EXTERNAL MODULE: ./components/discussions/apollo/transformOnSingleCommentRootQuery.ts
var transformOnSingleCommentRootQuery = __webpack_require__(14477);
;// CONCATENATED MODULE: ./components/discussions/mutations/ReplyToAssetDiscussionCommentMutation.tsx









function ReplyToAssetDiscussionCommentMutation(param) {
    var children = param.children;
    var amplitude = (0,Amplitude/* useAmplitude */.iz)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        mutation: ReplyToAssetDiscussionComment,
        children: function(replyToAssetDiscussionComment) {
            return children(function(param) {
                var assetId = param.assetId, assetType = param.assetType, replyToCommentId = param.replyToCommentId, replyToCommentShortId = param.replyToCommentShortId, bodyAsPlainText = param.bodyAsPlainText;
                amplitude.logEvent("Replied to a comment", {
                    assetId: assetId,
                    assetType: assetType,
                    contentCharacterCount: bodyAsPlainText.length
                });
                return replyToAssetDiscussionComment({
                    variables: {
                        commentId: replyToCommentId,
                        bodyAsPlainText: bodyAsPlainText
                    },
                    update: function(dataProxy, queryResult) {
                        if (!queryResult.data || !queryResult.data.replyToAssetDiscussionComment) {
                            return;
                        }
                        (0,transformOnAssetDiscussionCommentWithRepliesCountFields/* default */.Z)(dataProxy, replyToCommentId, function(fragmentData) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fragmentData), {
                                replies: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fragmentData.replies), {
                                    totalCount: fragmentData.replies.totalCount + 1
                                })
                            });
                        });
                        (0,transformOnDiscussionCommentsRootQuery/* default */.Z)(dataProxy, assetId, function(rootQueryData) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rootQueryData), {
                                nodes: rootQueryData.nodes.map(function(rootCommentNode) {
                                    if (!queryResult || !queryResult.data || !queryResult.data.replyToAssetDiscussionComment) {
                                        return rootCommentNode;
                                    }
                                    if (rootCommentNode._id !== replyToCommentId) {
                                        return rootCommentNode;
                                    }
                                    var nodesAfter = rootCommentNode.replies.nodes.concat(queryResult.data.replyToAssetDiscussionComment);
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rootCommentNode), {
                                        replies: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rootCommentNode.replies), {
                                            nodes: nodesAfter,
                                            totalCount: nodesAfter.length > rootCommentNode.replies.nodes.length ? Math.max(rootCommentNode.replies.totalCount + 1, 0) : rootCommentNode.replies.totalCount
                                        })
                                    });
                                })
                            });
                        });
                        (0,transformOnSingleCommentRootQuery/* default */.Z)(dataProxy, replyToCommentShortId, function(rootQueryData) {
                            if (!rootQueryData) {
                                return rootQueryData;
                            }
                            if (!queryResult || !queryResult.data || !queryResult.data.replyToAssetDiscussionComment) {
                                return rootQueryData;
                            }
                            var nodesAfter = rootQueryData.replies.nodes.concat(queryResult.data.replyToAssetDiscussionComment);
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rootQueryData), {
                                replies: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rootQueryData.replies), {
                                    nodes: nodesAfter,
                                    totalCount: nodesAfter.length > rootQueryData.replies.nodes.length ? Math.max(rootQueryData.replies.totalCount + 1, 0) : rootQueryData.replies.totalCount
                                })
                            });
                        });
                    }
                });
            });
        }
    });
};


/***/ }),

/***/ 37126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17283);
/* harmony import */ var _fragments_AssetDiscussionCommentFields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36913);
/* harmony import */ var _fragments_AssetDiscussionCommentReplyFields__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12149);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query AssetDiscussionCommentByShortId($commentShortId: ID!) {\n    assetDiscussionCommentByShortId(commentShortId: $commentShortId) {\n      __typename\n      replies {\n        totalCount\n        nodes {\n          ...AssetDiscussionCommentReplyFields\n        }\n        pageInfo {\n          hasNextPage\n          cursor\n        }\n      }\n      ...AssetDiscussionCommentFields\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_templateObject(), _fragments_AssetDiscussionCommentFields__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _fragments_AssetDiscussionCommentReplyFields__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z));


/***/ })

}]);